import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyGuestCarSearch = loadable(() => import(/* webpackChunkName: "content/car/search/guest" */ './GuestCarSearch'), 'GuestCarSearch');
